/**
 * A row's icon action (share, comments, edit, copy link…): a rounded square shared by tables' actions columns and the
 * job board's cards, so they all read the same. Put the icon straight inside; it's coloured from here and sized by
 * the caller's `ROW_ACTION_SIZE`. The hover fill is a foreground tint rather than a surface colour, so it shows on
 * white rows, hovered rows and grey lanes alike (and flips with the foreground in dark mode).
 */
export const ROW_ACTION_BUTTON =
    'grid shrink-0 place-items-center rounded-md text-foreground-muted [transition:scale_150ms_cubic-bezier(0.23,1,0.32,1),background-color_150ms_ease,color_150ms_ease] hover:bg-foreground/8 hover:text-foreground active:scale-[0.96] active:bg-foreground/12 disabled:pointer-events-none disabled:opacity-40'

/**
 * Button and icon size, kept apart from `ROW_ACTION_BUTTON` so two sizes never meet on one element. Tables: a 24px
 * square with a 15px icon, so a row of actions sits close together. Cards: 28px with 14px, for a roomier tap target.
 */
export const ROW_ACTION_SIZE = { table: 'size-6 [&>svg]:size-[15px]', card: 'size-7 [&>svg]:size-3.5' } as const

/** A non-interactive icon in an actions row (a status mark): pair it with `ROW_ACTION_SIZE` to line up with the buttons. */
export const ROW_ACTION_SLOT = 'grid shrink-0 place-items-center'
